// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"d3","pgUseBox":"d3","use-card-wrap":"d4","useCardWrap":"d4","use-box-wrap":"d5","useBoxWrap":"d5"};